export const linkRegexp =
  /((?:https?:\/\/)?(?:www\.)?[\da-z]+(?:\.[a-z]{2,})+(?:\/[\w-]+)*(?:[\w-]+\.)?\w{2,})/gi;
